import { requst } from '../config'

// 日历上数据
export const getHelicopterCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/helicopter/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getHelicopterDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getHelicopterByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/helicopter/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getHelicopterByIdApi = id => {
    const url = `/monitor/helicopter/${id}`
    return requst.get(url)
}

// 获取 Activities 数据
export const getHelicopterActivitiesDataApi = id => {
    const url = `/monitor/helicopter/activity/list?helicopterId=${id}`
    return requst.get(url)
}

// 提交 Helicopter 总结
export const postHelicopterCommentApi = commentData => {
    const url = `/monitor/helicopter`
    return requst.post(url, { ...commentData })
}

// 修改 Helicopter 总结
export const putHelicopterCommentApi = (commentData, id) => {
    const url = `/monitor/helicopter`
    return requst.put(url, { ...commentData, id })
}

// 提交 Activities 数据
export const postHelicopterActivitiesDataApi = (activitiesParams, id) => {
    const url = `/monitor/helicopter/activity/addOrUpdateBatch/${id}`
    return requst.post(url, activitiesParams)
}
